import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { UnsetCourseStructureCategory } from 'app/library/course-offerings-category/actions';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { filter, takeUntil } from 'rxjs/operators';

/**
 * Clears the current course structure category from NGXS when the user navigates away from
 * `/admin/course-offerings/category/:id` or switches to a different category id.
 */
@Injectable({ providedIn: 'root' })
export class CourseStructureCategoryRouteSyncService extends UnsubscribeOnDestroy {
    constructor(private _router: Router, private _store: Store) {
        super();

        let previousUrl = this._router.url;

        this._router.events
            .pipe(
                filter((event): event is NavigationEnd => event instanceof NavigationEnd),
                takeUntil(this._unsubscribeAll)
            )
            .subscribe((event: NavigationEnd) => {
                const nextUrl = event.urlAfterRedirects;
                const previousCategoryId = this.extractCategoryId(previousUrl);
                const nextCategoryId = this.extractCategoryId(nextUrl);
                const isLeavingCategoryRoute = this.isCourseOfferingsCategoryUrl(previousUrl) && !this.isCourseOfferingsCategoryUrl(nextUrl);
                const isSwitchingCategory = previousCategoryId && nextCategoryId && previousCategoryId !== nextCategoryId;

                if (isLeavingCategoryRoute || isSwitchingCategory) {
                    this._store.dispatch(new UnsetCourseStructureCategory());
                }

                previousUrl = nextUrl;
            });
    }

    private isCourseOfferingsCategoryUrl(url: string): boolean {
        return /\/admin\/course-offerings\/category\//.test(url);
    }

    private extractCategoryId(url: string): string | null {
        const match = url.match(/\/admin\/course-offerings\/category\/([^/?]+)/);
        return match ? match[1] : null;
    }
}
